import React from 'react';
import {motion} from 'framer-motion';
import {FiCalendar, FiClock, FiInfo, FiX, FiAlertTriangle} from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

function HolidayHoursPage() {
const holidayHours=[ 
  {holiday: "Christmas Eve",date: "December 24th",lunch: "Lunch is closed",dinner: "5:00 PM - 9:00 PM",notes: "Limited Holiday Menu Only",priority: "high"},
  {holiday: "Christmas Day",date: "December 25th",lunch: "Lunch is closed",dinner: "5:00 PM - 9:00 PM",notes: "Limited Holiday Menu Only",priority: "high"},
  {holiday: "New Year's Eve",date: "December 31st",lunch: "Lunch is closed",dinner: "5:00 PM - 9:00 PM",notes: "Regular Menu Served",priority: "high"},
  {holiday: "New Year's Day",date: "January 1st",lunch: "Lunch is closed",dinner: "5:00 PM - 9:00 PM",notes: "Regular Menu Served",priority: "high"},
  {holiday: "Thanksgiving",date: "Fourth Thursday in November",lunch: "CLOSED",dinner: "CLOSED",notes: "Closed all day",priority: "critical"},
  {holiday: "Independence Day",date: "July 4th",lunch: "CLOSED",dinner: "CLOSED",notes: "Closed all day",priority: "critical"} 
];

return ( 
  <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50"> 
    {/* Header */} 
    <header className="bg-white shadow-sm"> 
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6"> 
        <div className="flex items-center justify-between"> 
          <div> 
            <h1 className="text-3xl font-bold text-red-600">Holiday Hours</h1> 
            <p className="text-gray-600 mt-1">Rasa Sayang Asian Kitchen • 2024-2025</p> 
          </div> 
          <a href="/#/" className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors"> 
            <SafeIcon icon={FiX} className="inline w-4 h-4 mr-2" /> Back to Home 
          </a> 
        </div> 
      </div> 
    </header> 

    {/* Main Content */} 
    <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12"> 
      {/* Important Notice */} 
      <motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-8" > 
        <div className="flex items-start space-x-3"> 
          <SafeIcon icon={FiAlertTriangle} className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-1" /> 
          <div> 
            <h3 className="text-lg font-semibold text-yellow-800 mb-2">🚨 Menu Update</h3> 
            <p className="text-yellow-700"> 
              <strong>Important:</strong> On <strong>Christmas Eve & Christmas Day</strong>, we serve a <strong>LIMITED Holiday Menu</strong> only. <br/> 
              On <strong>New Year's Eve & New Year's Day</strong>, we serve our <strong>REGULAR Menu</strong> during dinner hours. 
            </p> 
          </div> 
        </div> 
      </motion.div> 

      {/* Quick Summary */} 
      <motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{delay: 0.1}} className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8" > 
        <div className="flex items-start space-x-3"> 
          <SafeIcon icon={FiInfo} className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" /> 
          <div> 
            <h3 className="text-lg font-semibold text-blue-800 mb-2">Holiday Schedule Summary</h3> 
            <div className="grid md:grid-cols-2 gap-4 text-blue-700"> 
              <div> 
                <p><strong>🎄 Christmas (12/24 & 12/25):</strong></p> 
                <p>• Lunch: CLOSED</p> 
                <p>• Dinner: OPEN (5PM - 9PM)</p> 
                <p>• Menu: <strong>Limited Holiday Menu</strong></p> 
              </div> 
              <div> 
                <p><strong>🎊 New Year's (12/31 & 01/01):</strong></p> 
                <p>• Lunch: CLOSED</p> 
                <p>• Dinner: OPEN (5PM - 9PM)</p> 
                <p>• Menu: <strong>Regular Menu</strong></p> 
              </div> 
            </div> 
          </div> 
        </div> 
      </motion.div> 

      {/* Holiday Hours Grid */} 
      <div className="grid gap-6"> 
        {holidayHours.map((holiday,index)=> ( 
          <motion.div key={holiday.holiday} initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{delay: index * 0.1}} className={`bg-white rounded-lg shadow-md p-6 ${holiday.priority==='critical' ? 'border-l-4 border-red-500' : 'border-l-4 border-orange-500'}`} > 
            <div className="flex items-start justify-between"> 
              <div className="flex-1"> 
                <div className="flex items-center space-x-3 mb-3"> 
                  <SafeIcon icon={FiCalendar} className="w-5 h-5 text-red-600" /> 
                  <h3 className="text-xl font-semibold text-gray-900">{holiday.holiday}</h3> 
                  {holiday.priority==='critical' && ( 
                    <span className="bg-red-100 text-red-800 text-xs font-medium px-2 py-1 rounded"> CLOSED ALL DAY </span> 
                  )} 
                </div> 
                <p className="text-gray-600 mb-4">{holiday.date}</p> 
                <div className="grid md:grid-cols-2 gap-4"> 
                  <div className={`flex items-center space-x-2 ${holiday.lunch==="CLOSED" || holiday.lunch==="Lunch is closed" ? "text-red-600" : "text-green-600"}`}> 
                    <SafeIcon icon={FiClock} className="w-4 h-4" /> 
                    <span className="font-medium">Lunch: {holiday.lunch}</span> 
                  </div> 
                  <div className={`flex items-center space-x-2 ${holiday.dinner==="CLOSED" ? "text-red-600" : "text-green-600"}`}> 
                    <SafeIcon icon={FiClock} className="w-4 h-4" /> 
                    <span className="font-medium">Dinner: {holiday.dinner}</span> 
                  </div> 
                </div> 
                {holiday.notes && ( 
                  <p className="text-sm text-gray-700 mt-3 font-medium bg-gray-50 p-2 rounded inline-block"> 📝 Note: {holiday.notes} </p> 
                )} 
              </div> 
            </div> 
          </motion.div> 
        ))} 
      </div> 

      {/* Regular Hours Reference */} 
      <motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{delay: 0.6}} className="bg-gray-50 rounded-lg p-6 mt-8" > 
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Regular Business Hours (Non-Holidays)</h3> 
        <div className="grid md:grid-cols-3 gap-6"> 
          <div> 
            <h4 className="font-medium text-gray-700 mb-2 font-bold">Monday</h4> 
            <p className="text-red-600 font-semibold">CLOSED</p> 
          </div>
          <div> 
            <h4 className="font-medium text-gray-700 mb-2">Tuesday - Friday</h4> 
            <p className="text-gray-600"> 
              <strong>Lunch:</strong> 11:30 AM - 2:30 PM<br /> 
              <strong>Dinner:</strong> 5:00 PM - 9:00 PM 
            </p> 
          </div> 
          <div> 
            <h4 className="font-medium text-gray-700 mb-2">Saturday & Sunday</h4> 
            <p className="text-gray-600"> 
              <strong>Lunch:</strong> CLOSED<br /> 
              <strong>Dinner:</strong> 5:00 PM - 9:00 PM 
            </p> 
          </div> 
        </div> 
      </motion.div> 

      {/* Contact Information */} 
      <motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{delay: 0.8}} className="bg-white rounded-lg shadow-md p-6 mt-8 text-center" > 
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Questions About Hours?</h3> 
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-6"> 
          <p className="text-gray-700"> <strong>📞 (770) 643-8812</strong> </p> 
          <p className="text-gray-700"> <strong>📍 1425 Market Blvd, Suite 1390, Roswell, GA 30076</strong> </p> 
        </div> 
        <p className="text-gray-600 mt-4"> Or ask our AI assistant - it's updated with the latest information! </p> 
      </motion.div> 
    </main> 
  </div> 
);
}
export default HolidayHoursPage;